import React, { useState, useMemo, useEffect, useRef } from 'react';
import { FilterSearch } from '../../../ui';
import { useInbox } from '../InboxContext';
import { EmailListItem } from './EmailListItem';
import { EmailListHeader } from './EmailListHeader';

function EmailList() {
  const { folderEmails, activeFolder, selectEmail } = useInbox();

  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const prevFolder = useRef(activeFolder);

  // Filter pipeline
  const filtered = useMemo(() => {
    let list = folderEmails;

    // Status filter
    if (statusFilter === 'unread') list = list.filter((e) => !e.isRead);
    if (statusFilter === 'starred') list = list.filter((e) => e.isStarred);

    // Multi-term search with + separator
    list = FilterSearch.filter(list, search, (e) => [
      e.from.name, e.from.email, e.subject, e.preview,
      e.primaryDomain, e.priority, e.bodyText,
    ]);

    // Sort by receivedAt desc
    return [...list].sort((a, b) => new Date(b.receivedAt) - new Date(a.receivedAt));
  }, [folderEmails, search, statusFilter]);

  // Auto-select first email ONLY when folder changes
  useEffect(() => {
    if (activeFolder !== prevFolder.current) {
      prevFolder.current = activeFolder;
      if (filtered.length > 0) {
        selectEmail(filtered[0].id);
      }
    }
  }, [activeFolder, filtered, selectEmail]);

  // Select first email on initial mount
  useEffect(() => {
    if (filtered.length > 0) selectEmail(filtered[0].id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    header: (
      <EmailListHeader
        search={search}
        setSearch={setSearch}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
      />
    ),
    list: filtered.map((email) => (
      <EmailListItem key={email.id} email={email} />
    )),
    count: filtered.length,
    totalCount: folderEmails.length,
  };
}

export { EmailList };
